module.exports = __webpack_public_path__ + "static/media/free-plan.5fb655f7.svg";